import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventWhistleRegularStopFirstHalftime extends DomainEvent<MatchEvent> {}
